import PrintIcon from './PrintIcon';

export default PrintIcon;
